<script setup lang="ts"></script>
<template>
  <div class="flex gap-2">
    <div  class="icon h-2 w-8">
      <i class="fas fa-arrow-right"></i>
    </div>
    <div class="w-full">
      <slot></slot>
    </div>
  </div>
</template>
